import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from 'components/Grid';
import { Testimonial } from 'patterns/Testimonial';
import { cx } from 'utility';
import * as styles from './TestimonialList.module.scss';

const propTypes = {
    background: PropTypes.bool,
    className: PropTypes.string,
    items: PropTypes.array,
    itemsPerRow: PropTypes.oneOf(['1', '2']),
};

const defaultProps = {
    background: false,
    className: '',
    items: [],
    itemsPerRow: '1',
};

function getClasses({ className, itemsPerRow }) {
    const classes = cx(
        className,
        styles['testimonialList'],
        styles[`testimonialList${itemsPerRow}`]
    );

    return classes || undefined;
}

function TestimonialList({
    background,
    className,
    items,
    itemsPerRow,
}) {
    const classes = getClasses({ className, itemsPerRow });
    const testimonialSize = (itemsPerRow === '1') ? 'large' : 'medium';

    return (
        <div className={classes}>
            <Grid>
                <div className={styles['container']}>
                    {items.map(({ testimonial_bio, testimonial_image, testimonial_quote, testimonial_name }, index) => {
                        const bio = testimonial_bio?.text;
                        const image = testimonial_image;
                        const quote = testimonial_quote?.text;
                        const name = testimonial_name?.text;

                        return (
                            <Testimonial
                                key={`testimonial-list-item-${index}`}
                                background={background}
                                bio={bio}
                                gridClassName={styles['testimonialGrid']}
                                image={image}
                                name={name}
                                quote={quote}
                                size={testimonialSize}
                            />
                        );
                    })}
                </div>
            </Grid>
        </div>
    );
}

TestimonialList.propTypes = propTypes;
TestimonialList.defaultProps = defaultProps;

export { TestimonialList };
